import type { GameStats } from "../game/game";

const f = (n: number, d = 0) => n.toFixed(d);
const signed = (n: number, d = 1) => (n >= 0 ? "+" : "") + n.toFixed(d);

/** Dev overlay (backtick): fps, speed, gear, rpm, slip angles, drift angle, InputFrame, tick count. */
export function DevOverlay({ stats }: { stats: GameStats }) {
  const i = stats.input;
  const rows: [string, string][] = [
    ["fps", f(stats.fps)],
    ["speed", `${f(stats.speedKmh)} km/h`],
    ["gear / rpm", `${stats.reversing ? "R" : stats.gear} / ${f(stats.rpm)}`],
    ["slip front", `${signed(stats.slipFrontDeg)}°`],
    ["slip rear", `${signed(stats.slipRearDeg)}°`],
    ["drift angle", `${signed(stats.driftDeg)}°`],
    ["input steer", `${i.steer}`],
    ["input throttle", `${i.throttle}`],
    ["input brake", `${i.brake}`],
    ["input handbrake", `${i.handbrake}`],
    ["tick", `${stats.tick}`],
    ["distance", `${f(stats.distance)} / ${f(stats.length)} m`],
    ["lateral", `${signed(stats.lateral)} m`],
    [
      "crashes / scrapes",
      `${stats.crashes} / ${stats.scrapes}${stats.wallContact ? "  WALL" : ""}`,
    ],
    [
      "assists cs/cap/thr",
      `${f(stats.assists.counterSteer, 1)} / ${f(stats.assists.angleCap, 1)} / ${f(stats.assists.throttleSmoothing, 1)}`,
    ],
  ];
  return (
    <div
      class="pointer-events-none absolute font-mono text-2xs leading-tight text-neon-cyan"
      style={{
        left: "calc(var(--safe-left) + 10px)",
        top: "calc(var(--safe-top) + 10px)",
        background: "rgba(5,7,10,0.72)",
        padding: "8px 10px",
        border: "1px solid var(--mp-color-neon-cyan-dim)",
      }}
    >
      {rows.map(([k, v]) => (
        <div key={k} class="flex justify-between gap-4">
          <span class="text-text-secondary">{k}</span>
          <span>{v}</span>
        </div>
      ))}
    </div>
  );
}
